import styled from "styled-components";

export const PickupAddr = styled.div`
  border-radius: 0.4rem;
  background-color: #ffffff;
  padding: 2.3rem 3rem;
  margin: ${(p) => (p.margin ? p.margin : "")};
  h3 {
    font-family: 'Rubik';
    font-size: 1.8rem;
    line-height: 2.2rem;
    font-weight: 600;
    color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
    margin-bottom: 3rem;
  }
  .cityName {
    font-size: 1.6rem;
    line-height: 2.2rem;
    font-weight: 600;
    color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
    margin-bottom: 1rem;
  }
  .cta {
    display: inline-flex;
    align-items: center;
    font-size: 1.4rem;
    ::after {
      border: solid #2276e3;
      border-width: 0 0.2rem 0.2rem 0;
      display: inline-block;
      padding: 0.3rem;
      transform: rotate(-45deg);
      content: "";
      margin-left: 0.5rem;
    }
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  marign-top: 0.1rem;
`;

export const SuccessMessage = styled.p`
  position: absolute;
  margin-top: -9px;
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${p => p.color ? p.color : '#2bac36'};
`;

export const SourceAsGstinCheckboxCont = styled.div(
  props => `
    padding-top: ${props.isAddressUpdate ? '20px' : '0'};
`)
